<template>
  <div class="menu-group-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'outlets_edit',  params: { uuid: uuid }}" class="float-left mr-1 main-link">{{$t('store.outlets')}}</router-link>
                  <span class="float-left mr-1 main-link">/</span>
                  <router-link :to="{ name: 'menu_control',  params: { uuid: uuid }}" class="float-left mr-1 main-link">{{$t('store.menu_control')}}</router-link>
                  / {{$t('store.menu_exclusion_editing')}}
                </h3>
              </strong>
            </div>

          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <!-- Filter -->
          <div slot="header">
            <label>{{$t('store.product_type')}}</label>
            <b-form-radio-group
              buttons
              v-model="mode"
              :options="options[$session.get('lang')]"
              @input="changeMode"
              name="radioBtnOutline" />
          </div>
          <b-row style="margin-bottom: 1rem; margin-top: 1rem">
            <b-col xl="4">
              <div class="pull-left mr-2">
                <b-input-group v-bind:prepend="$t('store.active')">
                  <b-form-select v-model="filter.active" v-bind:value="filter.active" :options="statuses[$session.get('lang')]" v-bind:placeholder="$t('store.active')">
                  </b-form-select>
                </b-input-group>
              </div>
              <div class="pull-left mr-2" v-if="mode == 'menu'">
                <b-input-group v-bind:prepend="$t('store.category')">
                  <b-form-select v-model="filter.category" v-bind:value="filter.category" :options="categories[$session.get('lang')]" v-bind:placeholder="$t('store.category')">
                  </b-form-select>
                </b-input-group>
              </div>
            </b-col>
            <b-col xl="8">
              <b-input-group>
                <select-dropdown v-bind:options="filter.options"  v-bind:selected="filter.selected" position="prepend" v-model="field" v-bind:all="false" prefix="menu">
                </select-dropdown>
                <b-form-input v-model="key"></b-form-input>
                <div class="input-group-append">
                  <b-input-group-append>
                    <b-btn @click="refreshData(key)"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                  </b-input-group-append>
                </div>
              </b-input-group>
            </b-col>

          </b-row>

          <!-- Size Exclusion -->
          <b-card class="mb-0">
            <div slot="header">
              <strong class="text-uppercase">
                {{$t('store.menu_exclusion_editing')}}
              </strong>
              <label class="switch switch-sm switch-text switch-info float-right mb-0" v-b-toggle.customise_content>
                <i class="fa fa-sort-down" v-if="commonStatus"></i>
                <i class="fa fa-sort-up" v-if="!commonStatus"></i>
              </label>
            </div>

            <b-collapse :visible.sync="commonStatus" id="customise_content">
              <b-row>
                <b-col cols="12">
                  <div class="rectangle-9-copy">
                    <div class="table-responsive">
                      <table class="table table-sm header-pointer">
                        <thead class="table-thead">
                        <tr>
                          <th scope="col" class="thead-th" v-for="item in dataTable.fields" :key="item.id" v-if="! (mode == 'combo' && (item.name == 'firsts' || item.name == 'category_id'))">
                            <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                            <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                            <span v-if="item.name != '#'">{{$t('store.'+item.name)}}</span>
                            <span v-else>
                            </span>
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="dataTable.items.length == 0">
                          <td class="text-center" :colspan="dataTable.fields.length + 1">
                            {{$t('message.no_data')}}
                          </td>
                        </tr>
                        <tr v-for="(item, index) in dataTable.items" :key="item.id">
                          <td scope="row" v-for="field in dataTable.fields" :key="field.id" v-if="!((field.name == 'firsts' || field.name == 'category_id') && mode == 'combo')">
                            <span v-if="field.type && field.type == 'checkbox'">
                              <b-form-checkbox class="checkbox-warning" v-model="modelMenu[index].value" value="1" unchecked-value="0" v-on:change="menuChanged(index)"></b-form-checkbox>
                            </span>
                            <span v-else-if="field.name == 'name' && mode == 'combo'" >
                            {{item[field.name][$session.get('lang')]}}
                            </span>
                            <span v-else-if="field.render != null" v-html="field.render(item[(field.name=='code'?'sku':field.name)], item)"></span>
                            <span v-else-if="field.render == null">
                              {{item[field.name[$session.get('lang')]]}}
                            </span>

                            <div v-if="field.name == 'firsts' && mode == 'menu'">
                              <div class="row first-layers" v-for="(f,i) in modelMenu[index].first_layers">
                                <div class="col-sm-3">
                                  <b-form-checkbox class="checkbox-warning clearfix" v-model="modelMenu[index].first_layers[i].value" :value="1" :unchecked-value="0" v-on:change="menuChanged(index)" :disabled="checkPermission($auth.user(),'rgm-role-editable')">
                                    <span>{{modelMenu[index].first_layers[i].name[$session.get('lang')]}}</span>
                                  </b-form-checkbox>
                                </div>
                                <div class="col-sm-9">
                                  <div class="clearfix" v-for="(s,j) in f.second_layers" >
                                    <b-form-checkbox class="checkbox-warning" v-model="modelMenu[index].first_layers[i].second_layers[j].value" value="1" unchecked-value="0" v-on:change="menuChanged(index)" :disabled="checkPermission($auth.user(),'rgm-role-editable')">
                                      <span >{{modelMenu[index].first_layers[i].second_layers[j].name[$session.get('lang')]}}</span>
                                    </b-form-checkbox>
                                  </div>
                                </div>
                                <hr>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-collapse>
            <b-row>
              <b-col>
                <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
              </b-col>
              <b-col col lg="1">
                <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3" />
              </b-col>
            </b-row>
            <div slot="footer">
              <button type="button" class="btn border-radius-4px bg-main float-left ml-4" @click="$router.back()"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              <div class="btn-save" v-if="checkPermission($auth.user(),'post.v1.product-menu-be.menu-outlets')">
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" v-if="isShowPublishButton" v-on:click="publishAll()"> {{$t('common.publish')}}
                </button>
                <span v-if="!isShowPublishButton" style="padding-right: 20px; font-weight: bold;" > {{$t('common.publishing')}} ... </span>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required} from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import vSelect from 'vue-select'
  import Tables from '../../tables/Tables'
  import Multiselect from 'vue-multiselect'
  import SelectDropdown from '../../../components/Partials/SelectDropdown'
  import DataTable from '../../../components/Partials/DataTable'
  let vm = null
  let cancel = null
  export default {
    name: 'MenuExclusionForm',
    props: {
      uuid: {
        type: String,
        required: true,
        default: 'create'
      }
    },
    components: {
      Tables,
      cSwitch,
      vSelect,
      Multiselect,
      SelectDropdown
    },
    data: function () {
      return {
        is_using_menu_v4_api: false,
        key: null,
        statuses: [],
        categories: [],
        mode: 'menu',
        options: {},
        dataTable: {
          items: [],
          fields: [{
            name: '#',
            type: 'checkbox',
            filter: false,
            sort: false,
            render: (data, row) => {
              return '<b-form-checkbox id="checkbox1" class="checkbox-warning" value="1" unchecked-value="0"></b-form-checkbox>'
            }
          },
            {
              name: 'image',
              filter: false,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return '<img src="' + data.desktop_thumbnail + '" width="100" height="100">'
              }
            },
            {
              name: 'category_id',
              filter: false,
              sort: false,
              render: (data, row) => {
                if (row.category == null || row.category.name == null) {
                  return ''
                }
                return row.category.name[this.$session.get('lang')]
              }
            },
            {
              name: 'name',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data[this.$session.get('lang')]
              }
            },
            {
              name: 'code',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'firsts',
              filter: false,
              sort: false
            },
            // {
            //   name: 'seconds',
            //   filter: false,
            //   sort: false
            // }
          ],
          sort: {
            field: null,
            type: 'asc'
          },
          currentPage: 1,
          total: 0,
          perPage: 20,
          source: null
        },
        field: null,
        filter: {
          options: [
            {
              name: 'name',
              label: 'marketing_name',
              filter: true,
              sort: true
            },
            {
              name: 'code',
              label: 'code',
              filter: true,
              sort: true
            }
          ],
          selected: null,
          startAt: this.$moment().subtract(7, 'days').format('YYYY-MM-DD'),
          endAt: this.$moment().format('YYYY-MM-DD'),
          date: [],
          active: '',
          category: '',
          name: '',
          code: ''
        },
        outletInfo: { code: '', name: {}, description: {}, address: '' },
        single: this.$auth.user().config.single,
        // images: this.$auth.user().config.single.images || [],
        item: {
          uuid: '',
          name: {},
          group_name: {},
          marketing_description: {},
          main_description: {},
          t_and_c: {},
          image: {},
          active: 1,
          menus: []
        },
        imageData: {},
        basicInformationStatus: true,
        commonStatus: true,
        processing: false,
        menuDealList: {},
        menuDealListUpdated: [],
        menuDealListSelected: '',
        isLoadingMenu: false,
        isLoadingMenuGroup: false,
        isShowPublishButton: false
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {

    },
    methods: {
      checkPermission(userInfo,permission){
        let modules = userInfo.modules ? userInfo.modules : {}
        let adminIds = [1, 34, 35, 62]
        return adminIds.indexOf(userInfo.user_id) !== -1 || modules.indexOf(permission) !== -1;
      },
      checkShowPublishButton() {
        if (vm.outletInfo.code) {
          let getCache = vm.getCacheLocalStorage(vm.outletInfo.code + '_' + 'pushlish')
          vm.isShowPublishButton = true
          if (!getCache.expired) {
            vm.isShowPublishButton = false
          }
        }
      },
      publishAll () {
        vm.saveMenuControl(() => {
          const menuParams = {
            'scope': 'all',
            'outlet': {
              'uuid': this.$route.params.uuid,
              'code': this.outletInfo.code
            }
          }
          if (!this.is_using_menu_v4_api || this.is_using_menu_v4_api === false) {
            menuParams.publish_menu_control = 1
          }
          vm.axios.menu.publishMenu(menuParams, function (response) {
            // vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
            // vm.ids = []
            // vm.refreshData()
          })

          vm.axios.menu.publishCombo({
            'scope': 'all',
            'outlet': {
              'uuid': this.$route.params.uuid,
              'code': this.outletInfo.code
            }
          }, function (response) {
            // vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
            // vm.ids = []
            // vm.refreshData()
          })
        })
        vm.isShowPublishButton = true

        if (vm.$store.getters.config.gms.outlet.config.show_push_to_prod) {
          vm.isShowPublishButton = false
          let time = Number(vm.$store.getters.config.manual_config.set_time_show_button_push_to_prod_store)
          time = Number.isNaN(time) ? 5 : time
          vm.setCacheLocalStorage(  this.outletInfo.code + '_' + 'pushlish', true, time )
        }
      },
      menuChanged (index) {
        this.modelMenu[index].hasChanged = true
      },
      /**
       * Save config menu control
       * */
      saveMenuControl (cb) {
        let data = {
          outlet_code: this.outletInfo.code
        }
        if (this.mode === 'menu') {
          data.menus = []
          for (let i in this.modelMenu) {
            if (this.modelMenu[i].hasChanged) {
              // let firstLayers = []
              // console.log(this.modelMenu[i])
              // for (let j in this.modelMenu[i].first_layers) {
              //   if (typeof this.modelMenu[i].first_layers[j] !== "undefined") {
              //     if (this.modelMenu[i].first_layers[j].value === 1) {
              //       firstLayers.push(this.modelMenu[i].first_layers[j])
              //     }
              //   }
              // }
              // this.modelMenu[i].first_layers = firstLayers
              data.menus.push(this.modelMenu[i])
            }
          }
        } else {
          data.combo = []
          for (let i in this.modelMenu) {
            if (this.modelMenu[i].hasChanged) {
              data.combo.push(this.modelMenu[i])
            }
          }
        }
        vm.axios.menu.saveMenuControl(data, function (response) {
          vm.refreshData()
          vm.$toastr.success(vm.$t('message.success'), vm.$t('message.success'), {})
          cb()
        }, function (data) {
          vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
        })
      },
      changeMode () {
        this.refreshData()
      },
      getListCategories () {
        vm.axios.menu.getListCategories(function (response) {
          vm.categories = []
          let langs = vm.$store.getters.languages
          for (let l in langs) {
            vm.statuses[langs[l]] = [
              { text: vm.$t('common.all', langs[l]), value: '' },
              { text: vm.$t('common.active', langs[l]), value: '1' },
              { text: vm.$t('common.inactive', langs[l]), value: '0' }
            ]
            vm.categories[langs[l]] = [{
              text: vm.$t('common.all', langs[l]),
              value: ''
            }]
            for (let c in response.data.data.items) {
              vm.categories[langs[l]].push({
                text: response.data.data.items[c]['name'][langs[l]] != null ? response.data.data.items[c]['name'][langs[l]] : '',
                value: response.data.data.items[c]['id']
              })
            }
          }
        })
      },
      refreshData (key) {
        if (cancel != null) {
          cancel()
        }

        // get params
        let _data = {
          page: this.dataTable.currentPage,
          limit: this.dataTable.perPage,
          sort_field: (this.dataTable.sort.field == 'code') ? 'sku' : this.dataTable.sort.field,
          sort_type: this.dataTable.sort.type,
          outlet_code: this.outletInfo.code
        }
        if (this.filter.category != '') {
          _data['category_id'] = this.filter.category
        }

        if (this.filter.active != '') {
          _data['active'] = this.filter.active
        }
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          if (this.field == 'code') {
            this.field = 'sku'
          }
          _data[this.field] = this.key.trim()
        }
        this.modelMenu = []
        this.dataTable.items = []
        this.modelMenuCheckAll = 0
        if (this.mode != 'combo') {
          vm.axios.menu.getMenuControl(_data,
            function (response) {
              vm.dataTable.items = response.data.data.items
              vm.modelMenu = []
              vm.dataTable.total = response.data.data.pagination.total
              for (let item in vm.dataTable.items) {
                let menucontrol = vm.dataTable.items[item].menu_controls
                if (menucontrol && menucontrol.length > 0) {
                  menucontrol = menucontrol[0].value.combo
                }
                if (menucontrol.group && menucontrol.group.length > 0 && menucontrol.group[0].singles && menucontrol.group[0].singles.length > 0) {
                  menucontrol = menucontrol.group[0].singles[0]
                }
                let menu = {value: menucontrol.sku ? 1 : 0, hasChanged: false, category_id: vm.dataTable.items[item].category_id, sku: vm.dataTable.items[item].sku, name: vm.dataTable.items[item].name, uuid: vm.dataTable.items[item].uuid, first_layers: []}
                for (let first in vm.dataTable.items[item].first_layers) {
                  let firstData = {value: 0, sku: vm.dataTable.items[item]['first_layers'][first].sku, name: vm.dataTable.items[item]['first_layers'][first].name, uuid: vm.dataTable.items[item]['first_layers'][first].uuid, second_layers: []}
                  let menuFirst = {}
                  if (Object.keys(menucontrol).length > 0) {
                    for (let m in menucontrol.first_layers) {
                      if (menucontrol.first_layers[m].uuid == firstData.uuid) {
                        if (menucontrol.first_layers[m].uuid == firstData.uuid && menucontrol.first_layers[m].second_layers.length === 0) {
                          firstData.value = menucontrol.first_layers[m].value
                        }
                        menuFirst = menucontrol.first_layers[m]
                        break
                      }
                    }
                  }
                  for (let second in vm.dataTable.items[item]['first_layers'][first].second_layers) {
                    let secondData = {value: 0, sku: vm.dataTable.items[item]['first_layers'][first]['second_layers'][second].sku, name: vm.dataTable.items[item]['first_layers'][first]['second_layers'][second].name, uuid: vm.dataTable.items[item]['first_layers'][first]['second_layers'][second].uuid}
                    if (Object.keys(menuFirst).length > 0) {
                      for (let s in menuFirst.second_layers) {
                        if (menuFirst.second_layers[s].uuid == secondData.uuid && menuFirst.second_layers[s].sku == secondData.sku) {
                          secondData.value = menuFirst.second_layers[s].value
                          break
                        }
                      }
                    }
                    firstData.second_layers.push(secondData)
                  }
                  menu.first_layers.push(firstData)
                }
                vm.modelMenu[item] = menu
              }
            })
        } else {
          _data.with = 'single,layers,menu_controls'
          _data['category_id'] = undefined
          vm.axios.menu.getMenuControlCombo(_data,
            function (response) {
              vm.dataTable.items = response.data.data.items
              vm.modelMenu = []
              vm.dataTable.total = response.data.data.pagination.total
              for (let item in vm.dataTable.items) {
                let menucontrol = vm.dataTable.items[item].menu_controls
                if (menucontrol && menucontrol.length > 0) {
                  menucontrol = menucontrol[0]
                }

                let _combo = {value: 0, hasChanged: false, sku: vm.dataTable.items[item].sku, name: vm.dataTable.items[item].name, uuid: vm.dataTable.items[item].uuid, group: []}
                if (menucontrol != null && Object.keys(menucontrol).length > 0 && menucontrol.value != null && menucontrol.value.combo != null) {
                  menucontrol = menucontrol.value.combo
                  _combo.value = menucontrol.sku ? 1 : 0
                }

                for (let group in vm.dataTable.items[item].groups) {
                  let dataGroup = {}
                  let _group = {value: 0, hasChanged: false, name: vm.dataTable.items[item].groups[group].name, uuid: vm.dataTable.items[item].groups[group].uuid, menus: []}
                  if (menucontrol != null && Object.keys(menucontrol).length > 0) {
                    for (let g in menucontrol.group) {
                      if (menucontrol.group[g].uuid == _group.uuid) {
                        dataGroup = menucontrol.group[g]
                      }
                    }
                  }
                  _group.value = dataGroup.value ? 1 : 0
                  for (let menuItem in vm.dataTable.items[item].groups[group].items) {
                    let dataMenu = {}
                    if(!vm.dataTable.items[item].groups[group].items[menuItem]['single']) {
                      continue
                    }
                    let _menu = {value: 0, hasChanged: false, sku: vm.dataTable.items[item].groups[group].items[menuItem]['single'].sku, name: vm.dataTable.items[item].groups[group].items[menuItem]['single'].name, image: vm.dataTable.items[item].groups[group].items[menuItem]['single'].image, uuid: vm.dataTable.items[item].groups[group].items[menuItem]['single'].uuid, first_layers: []}
                    if (Object.keys(dataGroup).length > 0) {
                      for (let m in dataGroup.singles) {
                        if (dataGroup.singles[m].uuid == _menu.uuid) {
                          dataMenu = dataGroup.singles[m]
                          break
                        }
                      }
                    }
                    _menu.value = dataMenu.sku ? 1 : 0
                    for (let first in vm.dataTable.items[item].groups[group].items[menuItem].first_layers) {
                      let dataFirst = {}
                      let _first = {value: 0, sku: vm.dataTable.items[item].groups[group].items[menuItem]['first_layers'][first].sku, name: vm.dataTable.items[item].groups[group].items[menuItem]['first_layers'][first].name, uuid: vm.dataTable.items[item].groups[group].items[menuItem]['first_layers'][first].uuid, second_layers: []}

                      if (Object.keys(dataMenu).length > 0) {
                        for (let f in dataMenu.first_layers) {
                          if (dataMenu.first_layers[f].uuid == _first.uuid) {
                            dataFirst = dataMenu.first_layers[f]
                            break
                          }
                        }
                      }
                      _first.value = dataFirst.sku ? 1 : 0
                      for (let second in vm.dataTable.items[item].groups[group].items[menuItem]['first_layers'][first].second_layers) {
                        let _second = {value: 0, sku: vm.dataTable.items[item].groups[group].items[menuItem]['first_layers'][first]['second_layers'][second].sku, name: vm.dataTable.items[item].groups[group].items[menuItem]['first_layers'][first]['second_layers'][second].name, uuid: vm.dataTable.items[item].groups[group].items[menuItem]['first_layers'][first]['second_layers'][second].uuid}

                        if (Object.keys(dataFirst).length > 0) {
                          for (let s in dataFirst.second_layers) {
                            if (dataFirst.second_layers[s].uuid == _second.uuid && dataFirst.second_layers[s].sku == _second.sku) {
                              _second.value = 1
                              break
                            }
                          }
                        }
                        _first.second_layers.push(_second)
                      }
                      _menu.first_layers.push(_first)
                    }
                    _group.menus.push(_menu)
                  }
                  _combo.group.push(_group)
                }
                vm.modelMenu[item] = _combo
              }
            })
        }
      }
    },
    created: function () {
      vm = this
      if(this.$store.getters.config.gms.outlet.config.show_menu_out_of_stock){
        this.$router.push({path: '/outlets/outlet-out-of-stock/menu-out-of-stock/' + this.$route.params.uuid});
      }
      let langs = vm.$store.getters.languages
      for (let l in langs) {
        this.options[langs[l]] = [
          { text: this.$t('store.menu', langs[l]), value: 'menu' },
          { text: this.$t('store.combo', langs[l]), value: 'combo' }
        ]
      }

      this.axios.outlet.getOutletDetail(this.$route.params.uuid,
        function (response) {
          const config = vm.$session.get('config')
          const manualConfig = vm._.get(config, 'manual_config', {}) || {}

          let item = response.data.data.item

          const isUsingMenuV4Api = (manualConfig.use_menu_v4_api_stores ? manualConfig.use_menu_v4_api_stores.split(',') : []).includes(item.code)
          vm.is_using_menu_v4_api = isUsingMenuV4Api
          console.log('is_using_menu_v4_api_menu_exclusion', vm.is_using_menu_v4_api)
          
          vm.$set(vm.outletInfo, 'id', item.id)
          vm.$set(vm.outletInfo, 'code', item.code)
          vm.$set(vm.outletInfo, 'name', item.name ? item.name : {})
          vm.$set(vm.outletInfo, 'description', item.description ? item.description : {})
          vm.$set(vm.outletInfo, 'address', item.address)
          if (vm.$store.getters.config.gms.outlet.config.show_push_to_prod) {
            vm.checkShowPublishButton()
          } else {
            vm.isShowPublishButton = true
          }
          vm.refreshData()
          vm.refreshDataFirstAndSeconds()
        })
      // for (let i in vm.dataTable.fields) {
      //   let field = vm.dataTable.fields[i].name
      //   if (vm.dataTable.fields[i].filter != null && vm.dataTable.fields[i].filter == true) {
      //     vm.filter.options.push(field)
      //   }
      //   if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort == true && vm.dataTable.sort.field == null) {
      //     vm.dataTable.sort = {
      //       field: field,
      //       type: 'asc'
      //     }
      //   }
      // }
      vm.$Progress.start()
      vm.getListCategories()
    },
    watch: {
      'dataTable.currentPage': function (val) {
        vm.refreshData()
      },
      'dataTable.perPage': function (val) {
        vm.refreshData()
      },
      'filter.active': function (val) {
        vm.refreshData()
      },
      'filter.category': function (val) {
        vm.refreshData()
      }
    }
  }
</script>

<style scoped>
  .menu-group-form .switch.switch-icon{
    margin-top: 5px;
  }

  .menu-group-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .menu-group-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .menu-group-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .menu-group-form .header-custom-switch .uppercase .first{
    margin-right: 10px;
  }

  .menu-group-form .header-custom-switch .uppercase .last{
    margin-left: 10px;
  }
  table tr th:last-child {
    width: 696px;
  }
</style>

<style>

  .menu-group-form .btn-save{
    float: right;
    margin-right: 22px;
  }
  .menu-group-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .preview-image {
    width: 100%;
  }
  .timeline {
    margin-top: 30px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .points {
    width: 100%;
    height: 30px;
    font-size: 30px;
    position: relative;
    z-index: 1;
  }
  .points i {
    position: absolute;
  }
  .step-commit {
    margin-left: calc(0% - 10px);
  }
  .step-updated {
    margin-left: calc(33% - 15px);
  }
  .step-publishing {
    margin-left: calc(66% - 15px);
  }
  .step-publish {
    margin-left: calc(100% - 20px);
  }
  .line-1 {
    position: absolute;
    margin-left: 15px;
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .line-2 {
    position: absolute;
    margin-left: calc(33% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .line-3 {
    position: absolute;
    margin-left: calc(66% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .current-point {
    font-size: 30px;
  }
  .img-min-height {
    min-height: 161px;
  }
  .custom-checkbox {
    padding-left: 1.5rem;
  }
  .min-width-200{
    min-width: 200px;
  }
  .menu-form .btn-save{
    float: right;
    margin-right: 22px;
  }
  .menu-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .menu-form div.header,
  .menu-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .rectangle-9-copy {
    width: auto;
    border: 1px solid #E1E6EB;
    border-radius: 3px;
    background-color: #F5F7F9;
  }

  .rectangle-9-copy-header {
    width: auto;
    border-radius: 3px 3px 0 0;
    background-color: #E1E6EB;
  }

  .thead-th {
    padding: 0.4rem !important;
  }

  .table-thead {
    background-color: #c3cbd4;
  }

  #menu_exclusion_btn {
    height: 39px;
    width: 149px;
  }
  .first-layers:not(:last-child) {
    border-bottom: 1px solid #cccccc;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/outlets/MenuExclusionForm.vue